<template>
    <b-container fluid v-if="client" class="align-self-center">
        <b-row>
            <b-col md="6" class="align-items-center justify-content-center text-center">
                <h3>Client information</h3>
            </b-col>
            <b-col md="6" class="align-items-center justify-content-center text-center">
                <h3>Actions</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6" class="p-4 align-items-center justify-content-center">
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Name:</b-col>
                    <b-col>{{client.name}}</b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Address: </b-col>
                    <b-col>{{client.address}}</b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Owner: </b-col>
                    <b-col>{{client.owner}}</b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Contact: </b-col>
                    <b-col>{{client.contact}}</b-col>
                </b-row>
            </b-col>
            <b-col md="6" class="p-4 flex-center flex-column">
                <b-row class="p-2 w-75">
                    <router-link class="w-100" :to="$route.path + '/edit'">
                        <b-btn size="lg" variant="primary" class="w-100">
                            Edit client
                        </b-btn>
                    </router-link>
                </b-row>
                <b-row class="p-2 w-75">
                    <b-btn size="lg" variant="danger" class="w-100" v-b-modal.deleteClient>
                        Delete client
                    </b-btn>
                </b-row>
            </b-col>
        </b-row>
        <b-modal centered
                 id="deleteClient" title="Potvrda"
                 @ok="deleteClient"
                 ok-variant="danger">
            <p class="my-4">Are you sure you want to delete this client?</p>
        </b-modal>
    </b-container>
</template>

<script>
    export default {
        name: 'Client',
        data () {
            return {
                client: null,
            }
        },
        methods: {
            deleteClient: function() {
                adamApi.delete(api.clients + this.client.id).
                then(response => {
                    this.$router.push('/clients');
                })
            }
        },
        created () {
            adamApi.get(api.clients + this.$route.params.id).
            then(response => {
                if (response.status === 200) {
                    this.client = response.data;
                }
            })
        }
    }
</script>
